import { Draggable } from 'react-beautiful-dnd';
import styled from 'styled-components';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIDragHandleHoverContainer from 'UIComponents/draggable/UIDragHandleHoverContainer';
import UIDragHandle from 'UIComponents/draggable/UIDragHandle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DragHandle = styled.div.withConfig({
  displayName: "SortableListItem__DragHandle",
  componentId: "r8lvg5-0"
})([":hover{display:block;background-color:", ";}"], GREAT_WHITE);
const SortableListItem = ({
  children,
  index
}) => /*#__PURE__*/_jsx(Draggable, {
  disableInteractiveElementBlocking: true,
  draggableId: children.props.sortKey,
  index: index,
  children: provided => {
    return /*#__PURE__*/_jsx("div", Object.assign({
      ref: provided.innerRef
    }, provided.draggableProps, provided.dragHandleProps, {
      tabIndex: -1,
      children: /*#__PURE__*/_jsx(UIDragHandleHoverContainer, {
        children: /*#__PURE__*/_jsxs(UIFlex, {
          align: "center",
          children: [/*#__PURE__*/_jsx(DragHandle, {
            children: /*#__PURE__*/_jsx(UIDragHandle, {})
          }), children]
        })
      })
    }));
  }
});
SortableListItem.displayName = 'SortableListItem';
export default SortableListItem;